import { InputStartAdornment, TextInputV4 } from '@labrav/react-components'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { FormikProps, useFormikContext } from 'formik'
import { get } from 'lodash'
import {
  AzureOfferPlan,
  AzurePricingType,
} from '../../../../modules/privateOffer/types'
import { Product } from '../../../../modules/productsListing/types'
import { DisplayValueData } from '../Plan/PlanRow/MeteringDimensions/MeteringDimensions'
import { useStyles } from '../Plan/PlanRow/PlanRow.styles'
import {
  getVmPlanTcvValue,
  getVmSystemMeterPriceTitle,
  getVmTcvFromMeters,
  shouldShowVmTcv,
} from '../../../../components/MicrosoftFormComponent/VmPlan/vmPlanUtils'
import { isNonEmptyNumber } from '@labrav/common'

const useVmPlanStyles = makeStyles()(theme => ({
  fieldWidth248: {
    width: theme.spacing(31),
  },
}))

const VmPlanTcv = ({
  plan,
  index,
  product,
}: {
  plan: AzureOfferPlan
  index: number
  product: Product
}) => {
  const { classes } = useStyles()
  const { classes: vmClasses } = useVmPlanStyles()
  const { values, touched, errors, handleChange, handleBlur } =
    useFormikContext() as FormikProps<Record<string, unknown>>

  const formPlan = (values?.plans as AzureOfferPlan[])?.[index] || plan

  if (!shouldShowVmTcv(formPlan, product)) {
    return null
  }

  const azurePricingType = values?.azurePricingType as AzurePricingType
  const isDiscountPricing =
    azurePricingType === AzurePricingType.LABRA_PERCENTAGE

  const tcvTitle = getVmSystemMeterPriceTitle(
    formPlan,
    azurePricingType,
    product
  )

  const tcvKeyName = `plans.${index}.pricing.recurrentPrice.prices.0.pricePerPaymentInUsd`
  const tcvValue: number | undefined =
    (get(values, tcvKeyName) as number | undefined) ??
    getVmPlanTcvValue(formPlan) ??
    getVmTcvFromMeters(formPlan?.pricing?.customMeters?.meters)

  return (
    <Grid container width={'100%'} spacing={3}>
      <Grid size={6} width={'248px'}>
        <div className={vmClasses.fieldWidth248}>
          {!isDiscountPricing ? (
            <TextInputV4
              keyName={tcvKeyName}
              title={tcvTitle}
              type="number"
              placeHolder=""
              keyToPrevent={['+', '-', 'e']}
              value={isNonEmptyNumber(tcvValue) ? tcvValue! : ''}
              updatedValue={isNonEmptyNumber(tcvValue) ? tcvValue! : ''}
              startAdornment={<InputStartAdornment text="$" />}
              alignRight
              isError={
                !!(
                  get(touched, tcvKeyName, false) &&
                  get(errors, tcvKeyName, false)
                )
              }
              onChange={handleChange}
              isReadOnly={false}
              isRequired={false}
              errorText={
                (!!get(touched, tcvKeyName, false) &&
                  get(errors, tcvKeyName, '')) ||
                ''
              }
              showSpinner={false}
              onBlur={handleBlur}
            />
          ) : (
            <div className={classes.discountedTcv}>
              <div className={classes.title}>{tcvTitle}</div>
              <DisplayValueData id={tcvKeyName} value={tcvValue} isPrice />
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  )
}

export const VmPlanPricing = ({
  index,
  plan,
  product,
}: {
  index: number
  plan: AzureOfferPlan
  product: Product
}) => {
  if (!shouldShowVmTcv(plan, product)) {
    return null
  }

  return <VmPlanTcv plan={plan} index={index} product={product} />
}
